import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import CustomSelect from '../../../common/formElements/CustomSelect';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';

class BrowserStorageLocationField extends Component {
  browserStorageLocationOptions = (showDefaultOption) => {
    return [
      {
        value: 'SESSION_STORAGE',
        label: `Session Storage${showDefaultOption ? ' (Default)' : ''}`,
      },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
      { value: 'INDEXED_DB', label: 'IndexedDB' },
    ];
  };

  render() {
    const {
      fieldName,
      values,
      setFieldValue,
      setFieldTouched,
      description,
      isMulti,
      label,
      placeholder,
      showDefaultOption = true,
      infoDescription,
    } = this.props;

    return (
      <div className="form-group">
        <FormFieldWithLabel
          cta={false}
          label={label || 'Session Storage Location (Optional)'}
          icon="select"
          infoIcon={true}
          infoDescription={
            infoDescription ||
            description ||
            `Select the browser storage location where you want to set the key:value data in your web browser storage.`
          }
        >
          <CustomSelect
            name={fieldName}
            isMulti={isMulti || false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={this.browserStorageLocationOptions(showDefaultOption)}
            value={values[fieldName] || 'SESSION_STORAGE'}
            placeholder={placeholder || 'Session Storage Location (Optional)'}
          />
        </FormFieldWithLabel>
        <small style={{ paddingLeft: '9%' }}>
          {description ||
            `Select a browser storage location to set a value (Default: Session Storage).`}
        </small>
        <ErrorMessage name={fieldName} component="p" className="text-error ml-5" />
      </div>
    );
  }
}

export default BrowserStorageLocationField;
